import { render, staticRenderFns } from "./addPhone.vue?vue&type=template&id=b9ce81fe&scoped=true"
import script from "./addPhone.vue?vue&type=script&lang=js"
export * from "./addPhone.vue?vue&type=script&lang=js"
import style0 from "./addPhone.vue?vue&type=style&index=0&id=b9ce81fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ce81fe",
  null
  
)

export default component.exports